'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components';
import { Checkbox, useTableState } from '@repo/ui/components';
import { ChevronDown, Columns3 } from 'lucide-react';
import React, { useState } from 'react';
export const TableSettings = () => {
  'use no memo';

  const {
    table
  } = useTableState();
  const headers = table.getAllColumns() ?? [];
  return <Popover>
      <PopoverTrigger asChild>
        <Button className={'max-md:size-10'} variant={'outline'}>
          <Columns3 size={16} /> <ChevronDown />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <div>
          <p className={'p-3 font-medium'}>Customize Columns</p>
        </div>
        <div>
          {headers.map(column => <SettingsCheckbox checked={column.getIsVisible()} key={column.id} label={column.columnDef.header} onChange={column.toggleVisibility} />)}
        </div>
      </PopoverContent>
    </Popover>;
};
const SettingsCheckbox = t0 => {
  const $ = _c(16);
  let label;
  let onChange;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      onChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = onChange;
    $[3] = props;
  } else {
    label = $[1];
    onChange = $[2];
    props = $[3];
  }
  const [checked, setChecked] = useState(props.checked);
  const t1 = label;
  let t2;
  if ($[4] !== onChange) {
    t2 = event => {
      setChecked(event);
      if (typeof event === "boolean") {
        onChange(event);
      }
    };
    $[4] = onChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== checked || $[7] !== t1 || $[8] !== t2) {
    t3 = <Checkbox checked={checked} id={t1} onCheckedChange={t2} />;
    $[6] = checked;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = label;
  const t5 = label;
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <label htmlFor={t4}>{t5}</label>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="flex items-center gap-2 border-b border-[#F5F5F5] px-3 py-2 last:border-b-0 dark:text-[#b6c4d2]">{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};